export const createPageRange = (start, end) =>
  Array.from({ length: Math.max(0, end - start + 1) }, (_, index) => start + index);

export const buildVisibleModel = (minPage, maxPage, currentPage, maxVisibleItems = 7) => {
  const totalPages = maxPage - minPage + 1;
  const visibleCap = Math.max(5, maxVisibleItems);

  if (totalPages <= visibleCap) {
    return {
      leadingHidden: [],
      visiblePages: createPageRange(minPage, maxPage),
      trailingHidden: [],
    };
  }

  if (visibleCap <= 5) {
    if (currentPage <= minPage + 2) {
      return {
        leadingHidden: [],
        visiblePages: [minPage, minPage + 1, minPage + 2, maxPage],
        trailingHidden: createPageRange(minPage + 3, maxPage - 1),
      };
    }

    if (currentPage >= maxPage - 2) {
      return {
        leadingHidden: createPageRange(minPage + 1, maxPage - 3),
        visiblePages: [minPage, maxPage - 2, maxPage - 1, maxPage],
        trailingHidden: [],
      };
    }

    return {
      leadingHidden: createPageRange(minPage + 1, currentPage - 1),
      visiblePages: [minPage, currentPage, maxPage],
      trailingHidden: createPageRange(currentPage + 1, maxPage - 1),
    };
  }

  const leftSibling = Math.max(currentPage - 1, minPage + 1);
  const rightSibling = Math.min(currentPage + 1, maxPage - 1);
  const showLeftGap = leftSibling > minPage + 1;
  const showRightGap = rightSibling < maxPage - 1;

  if (!showLeftGap && showRightGap) {
    return {
      leadingHidden: [],
      visiblePages: [...createPageRange(minPage, minPage + 4), maxPage],
      trailingHidden: createPageRange(minPage + 5, maxPage - 1),
    };
  }

  if (showLeftGap && !showRightGap) {
    return {
      leadingHidden: createPageRange(minPage + 1, maxPage - 5),
      visiblePages: [minPage, ...createPageRange(maxPage - 4, maxPage)],
      trailingHidden: [],
    };
  }

  return {
    leadingHidden: createPageRange(minPage + 1, leftSibling - 1),
    visiblePages: [minPage, currentPage - 1, currentPage, currentPage + 1, maxPage],
    trailingHidden: createPageRange(rightSibling + 1, maxPage - 1),
  };
};
